<template>
  <div class="bg-white padding-five-all">
    <h5 class="color-orange">{{ messages.FILTERS_TITLE }}</h5>

    <b-container fluid>
      <b-row class="padding-ten-tb align-items-end">
        <b-col
          v-for="slot in filterSlots"
          :key="slot"
          cols="12"
          :lg="filterColLg"
          class="mb-3 mb-lg-0"
        >
          <template v-if="slot === 'periodo'">
            <label class="text-grey">{{ messages.FILTER_CORTE_LABEL }}</label>
            <b-form-select
              v-if="!loadingCatalogs"
              :key="'periodo-' + periodoOptions.length"
              class="grey-input"
              :value="filters.idPeriodo"
              :options="periodoOptions"
              :disabled="loading"
              @input="updateFilter('idPeriodo', $event)"
            />
            <b-form-select
              v-else
              class="grey-input"
              disabled
              :value="filters.idPeriodo"
              :options="periodoLoadingOptions"
            />
          </template>

          <template v-else-if="slot === 'proveedor'">
            <label class="text-grey">{{
              messages.FILTER_PROVEEDOR_LABEL
            }}</label>
            <b-form-select
              v-if="!loadingCatalogs"
              class="grey-input"
              :value="filters.idProv"
              :options="proveedorOptions"
              :disabled="loading"
              @input="updateFilter('idProv', $event)"
            />
            <b-form-select
              v-else
              class="grey-input"
              disabled
              :value="0"
              :options="proveedorLoadingOptions"
            />
          </template>

          <template v-else-if="slot === 'tienda'">
            <label class="text-grey">{{ messages.FILTER_TIENDA_LABEL }}</label>
            <ComboStore
              :value="filters.codigoTienda"
              :disabled="loading || loadingCatalogs"
              @input="updateFilter('codigoTienda', $event)"
            />
          </template>

          <template v-else-if="slot === 'estadoOs'">
            <label class="text-grey">{{
              messages.FILTER_ESTADO_OS_LABEL
            }}</label>
            <b-form-select
              v-if="!loadingCatalogs"
              class="grey-input"
              :value="filters.estadoOs"
              :options="estadoOsOptions"
              :disabled="loading"
              @input="updateFilter('estadoOs', $event)"
            />
            <b-form-select
              v-else
              class="grey-input"
              disabled
              :value="0"
              :options="estadoOsLoadingOptions"
            />
          </template>

          <template v-else-if="slot === 'estadoLiquidacionOs'">
            <label class="text-grey">{{
              messages.FILTER_ESTADO_LIQUIDACION_OS_LABEL
            }}</label>
            <b-form-select
              class="grey-input"
              :value="filters.estadoLiquidacionOs"
              :options="estadoLiquidacionOsOptions"
              :disabled="loading"
              @input="updateFilter('estadoLiquidacionOs', $event)"
            />
          </template>

                    <template v-else-if="slot === 'detSequenceId'">
            <label class="text-grey">{{ messages.FILTER_NRO_OS_LABEL }}</label>
            <b-form-input
              class="grey-input"
              :value="filters.detSequenceId"
              placeholder="Ej. 556844-1"
              :disabled="loading"
              @input="updateTextFilter('detSequenceId', $event)"
              @keyup.enter="$emit('search')"
            />
          </template>
        </b-col>
      </b-row>

      <b-row class="align-items-center">
        <b-col cols="12" class="text-center text-lg-left">
          <b-button
            class="btn-orange hidden-icon mr-2"
            :disabled="loading"
            @click="$emit('search')"
          >
            <font-awesome-icon icon="search" />
            {{ messages.SEARCH_BUTTON }}
          </b-button>
          <b-button
            class="bg-grey-btn hidden-icon"
            :disabled="loading"
            @click="$emit('clear')"
          >
            <font-awesome-icon icon="broom" />
            {{ messages.CLEAR_BUTTON }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ComboStore from "@/components/ComboStore.vue";
import {
  fetchLiquidacionPeriodoSelectOptions,
  fetchProviderSelectOptionsByCentralized,
  fetchOsEstadoSelectOptions,
} from "@/services/service-catalog/service-catalog.api";
import {
  GESTOR_CENTRALIZADO_FILTER_SLOTS,
  getDefaultPeriodoFilterOptions,
  getDefaultProveedorFilterOptions,
  getDefaultEstadoOsFilterOptions,
  getEstadoLiquidacionOsFilterOptions,
  MESSAGES,
} from "@/services/gestor-centralizado/gestor-centralizado.constants";
import {
  areGestorCentralizadoFiltersEqual,
  getDefaultGestorCentralizadoFilters,
  normalizeGestorCentralizadoFilters,
} from "@/services/gestor-centralizado/gestor-centralizado.contract";

export default {
  name: "GestorCentralizadoFiltersPanel",

  components: {
    ComboStore,
  },

  props: {
    filters: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      messages: MESSAGES,
      periodoOptions: getDefaultPeriodoFilterOptions(),
      proveedorOptions: getDefaultProveedorFilterOptions(),
      estadoOsOptions: getDefaultEstadoOsFilterOptions(),
      estadoLiquidacionOsOptions: getEstadoLiquidacionOsFilterOptions(),
      loadingCatalogs: false,
    };
  },

  computed: {
    filterSlots() {
      return GESTOR_CENTRALIZADO_FILTER_SLOTS;
    },

    filterColLg() {
      const count = this.filterSlots.length;
      if (!count) return 12;
      return Math.floor(12 / count);
    },

    periodoLoadingOptions() {
      const current = Number(this.filters.idPeriodo ?? 0);
      if (current > 0) {
        return [{ value: current, text: "Cargando cortes..." }];
      }
      return [{ value: 0, text: "Cargando cortes..." }];
    },

    proveedorLoadingOptions() {
      return [{ value: 0, text: "Cargando proveedores..." }];
    },

    estadoOsLoadingOptions() {
      return [{ value: 0, text: "Cargando estados..." }];
    },
    selectedProveedorOption() {
      return (
        this.proveedorOptions.find((o) => o.value === this.filters.idProv) ||
        null
      );
    },
    selectedPeriodoOption() {
      return (
        this.periodoOptions.find((o) => o.value === this.filters.idPeriodo) ||
        null
      );
    },
  },
  watch: {
    selectedProveedorOption: {
      immediate: true,
      handler(option) {
        this.$emit("proveedor-label-change", option ? option.text : "");
      },
    },
    selectedPeriodoOption: {
      immediate: true,
      handler(option) {
        this.$emit("periodo-label-change", option ? option.text : "");
      },
    },
  },
  created() {
    this.loadCatalogOptions();
  },

  methods: {
    async loadCatalogOptions() {
      this.loadingCatalogs = true;

      const results = await Promise.allSettled([
        fetchLiquidacionPeriodoSelectOptions(),
        fetchProviderSelectOptionsByCentralized(),
        fetchOsEstadoSelectOptions(),
      ]);

      const [periodoResult, proveedorResult, estadoOsResult] = results;

      if (periodoResult.status === "fulfilled") {
        this.periodoOptions = periodoResult.value;
        this.applyDefaultPeriodoIfNeeded();
      } else {
        console.error(periodoResult.reason);
        this.periodoOptions = getDefaultPeriodoFilterOptions();
      }

      if (proveedorResult.status === "fulfilled") {
        this.proveedorOptions = proveedorResult.value;
      } else {
        console.error(proveedorResult.reason);
        this.proveedorOptions = getDefaultProveedorFilterOptions();
      }

      if (estadoOsResult.status === "fulfilled") {
        this.estadoOsOptions = estadoOsResult.value;
      } else {
        console.error(estadoOsResult.reason);
        this.estadoOsOptions = getDefaultEstadoOsFilterOptions();
      }

      this.loadingCatalogs = false;
    },

    applyDefaultPeriodoIfNeeded() {
      const currentPeriodo = Number(this.filters.idPeriodo ?? 0);
      if (currentPeriodo > 0) return;

      const defaults = getDefaultGestorCentralizadoFilters();
      const defaultPeriodo = Number(defaults.idPeriodo ?? 0);
      if (defaultPeriodo <= 0) return;

      const exists = this.periodoOptions.some(
        (option) => Number(option.value) === defaultPeriodo,
      );
      if (!exists) return;

      this.emitFiltersIfChanged({
        ...this.filters,
        idPeriodo: defaultPeriodo,
      });
    },

    emitFiltersIfChanged(nextFilters) {
      const normalized = normalizeGestorCentralizadoFilters(nextFilters);

      if (areGestorCentralizadoFiltersEqual(normalized, this.filters)) {
        return;
      }

      this.$emit("update:filters", normalized);
    },
        updateTextFilter(key, value) {
      this.emitFiltersIfChanged({
        ...this.filters,
        [key]: String(value ?? ""),
      });
    },
    updateFilter(key, value) {
      if (value === null || value === undefined || value === "") return;

      const parsedValue = Number(value);
      const normalizedValue = Number.isFinite(parsedValue) ? parsedValue : 0;

      this.emitFiltersIfChanged({
        ...this.filters,
        [key]: normalizedValue,
      });
    },
  },
};
</script>
